import React , { useState, useRef, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CContainer,
} from '@coreui/react'
import styled from 'styled-components'
import CardContent from './CardContent';
import ModalContent from '../../../hooks/ModalContent'
import api from '../../../api/api'

export default function TablaPropietarios({
  user,
  //traducciones
  translation={},
  language="",
}) {
    const navigate = useNavigate();
    //Variables
    const showModal = useRef(); //referencia del hijo

    //data almacenada en el location
    const location = useLocation();
    let locationData = location.state ? location.state?.dataCache : null

    //para los endpoints
    const config = {
      headers: {
        Authorization: `Token ${user?.token}`,
      },
    };

    //configuracion de busqueda, filtrado y paginacion
    const [dataConfig, setDataConfig] = useState({
      searchTerm: locationData?.dataConfig?.searchTerm ? locationData?.dataConfig?.searchTerm : "",
      filter: locationData?.dataConfig?.filter ? locationData?.dataConfig?.filter : 0,
      itemsPerPage: locationData?.dataConfig?.itemsPerPage ? locationData?.dataConfig?.itemsPerPage : 6,
      cantRegistros: 0,
      currentPage: 1,
      lastPage: 1,
      minPageNumberLimit: locationData?.dataConfig?.minPageNumberLimit ? locationData?.dataConfig?.minPageNumberLimit : 0,
      maxPageNumberLimit: locationData?.dataConfig?.maxPageNumberLimit ? locationData?.dataConfig?.maxPageNumberLimit : 5,
      //estos valores nunca se actualizan para saber el minimo y maximo
      pageNumberLimit: 5,
      pageMinNumber: 0,

    });
    //con esta variable validamos si el CU se esta abriendo por primera vez
    const [inicio, setInicio] = useState(true);
    const [loadingData, setLoadingData] = useState(true);
  

    //arreglo con los filtros para el select
    const [filtros, setFiltros] = useState([
      { value: 0, label: `${translation[language]?.etiqueta_todos ? translation[language]?.etiqueta_todos : "Todos"}`},
      { value: 1, label: `${translation[language]?.etiqueta_activos ? translation[language]?.etiqueta_activos : "Activos"}`},
      { value: 2, label: `${translation[language]?.etiqueta_inactivos ? translation[language]?.etiqueta_inactivos : "Inactivos"}`},
      { value: 3, label: `${translation[language]?.etiqueta_transicion ? translation[language]?.etiqueta_transicion : "En transición"}`},
    ])

    //arreglo que almacena los propietarios
    const [propietarios, setPropietarios] = useState([]);

    //funciones

    //Con esta funcion escuchamos los cambios en los filtros
    const handleChangeFiltros = (e) => {
      //Cuando se coloca algo en el buscador
      if (e.target.name === "search") {
        if (e.target.value === "") {
          setDataConfig({...dataConfig, searchTerm: ""})
        } else {
          setDataConfig({...dataConfig, searchTerm: e.target.value})
        }
      }
    }

    //Con esta funcion obtenemos los propietarios
    const getData = (inicio = true, page = 1, maxPageNumberLimit=null, minPageNumberLimit=null) => {
      window.scrollTo(0, 0);
      setLoadingData(true)
      let newDataConfig;
      let sr = dataConfig
      // Esta es la variable que almacenara los parametros que enviaremos al endpoint
      let obj = {
        page: page,
        page_size: sr.itemsPerPage,
        filtro: sr.filter,
      };
      let terms;
      //si hay busqueda le agregamos los parametros de busqueda
      if (sr.searchTerm !=="") {
        terms = {
          ...obj,
          nombre: sr.searchTerm,
          email: sr.searchTerm,
        };
      } else {
        terms = obj
      }
      const newConfig = {...config, params: terms}
      api.get(`/get_propietarios`, newConfig).then(response => {
        newDataConfig = {
          ...dataConfig,
          cantRegistros: response.data.total,
          lastPage: response.data.last_page,
          currentPage: page,
          maxPageNumberLimit: parseInt(maxPageNumberLimit)>=0 ? maxPageNumberLimit : dataConfig.maxPageNumberLimit, 
          minPageNumberLimit: parseInt(minPageNumberLimit)>=0 ? minPageNumberLimit : dataConfig.minPageNumberLimit,
        }
        setDataConfig(JSON.parse(JSON.stringify(newDataConfig)))
        setLoadingData(false)
        setPropietarios(response.data.propietarios)
        if(inicio){
          setInicio(false)
        }
      }).catch(err => {
        switch (err?.response?.status) {
          case 403:
            showModal?.current?.content?.info(
              1, //accion que tomara 
              `${translation[language]?.msg_autorizacion_requerida ? translation[language]?.msg_autorizacion_requerida : "Autorización requerida, por favor inicie sesión."}`, //mensaje principal
              null, //mensaje secundario
              false, //indica si hay o no boton de cancelar
              `${translation[language]?.boton_aceptar ? translation[language]?.boton_aceptar : "Aceptar"}`, //texto de boton de aceptar
              `${translation[language]?.boton_cancelar ? translation[language]?.boton_cancelar : "Cancelar"}` //texto de boton de cancelar
            );
            break;
          case 404:
            newDataConfig = {
              ...dataConfig,
              cantRegistros: 0,
              lastPage: 1,
              currentPage: 1,
              maxPageNumberLimit: dataConfig.pageNumberLimit, 
              minPageNumberLimit: dataConfig.pageMinNumber,
            }
            setDataConfig(JSON.parse(JSON.stringify(newDataConfig)))
            setLoadingData(false)
            setPropietarios([])
            if(inicio){
              setInicio(false)
            }         
          break;
          default:
            break;
        }
      })
    }

    //con esto vamos a editar un propietario
    const goToEditarPropietario = (item) => {
      let dataCache = {
        id_propietario: item.id_propietario,
        oldDataCache: {
          dataConfig: dataConfig,
        }
      }
      navigate('/admin-editar-propietario', { state: { dataCache: dataCache}})
    }

    //con esto vamos a ir a ver artes de un propietario
    const goToVerArtesPropietario = (item) => {
      let dataCache = {
        propietario: item,
        from: "/admin-propietarios",
        oldDataCache: {
          dataConfig: dataConfig,
        }
      }
      navigate('/admin-artes-propietario', { state: { dataCache: dataCache}})
    }
    

    //con esto enviamos al usuario a la vista de CU4.2 
    const handleGoToTransferirArte = (item) => {
      if(item.id_propietario){
        let dataCache = {
          admin: true,
          from: '/admin-propietarios',
          action: 2,
          id_propietario_pieza: null,
          fk_propietario: item.id_propietario,
          oldDataCache: {
            dataConfig: dataConfig,
          }
        }
        navigate('/transferir-arte', { state: { dataCache: dataCache}})
      }
    }

    //con este efecto llamamos a la funcion para obtener la data la primera vez que inicia el CU
    useEffect(()=> {
      window.scrollTo(0, 0);
      if(!user){
        showModal?.current?.content?.authentication(
          1, //accion que tomara 
          `${translation[language]?.msg_autorizacion_requerida ? translation[language]?.msg_autorizacion_requerida : "Autorización requerida, por favor inicie sesión."}`, // mensaje principal
          `${translation[language]?.boton_aceptar ? translation[language]?.boton_aceptar : "Aceptar"}`, //texto de boton de aceptar
        );
        return;
      }
      if(user?.grupo_actor !== 1){
        showModal?.current?.content?.info(
          1, //accion que tomara 
          `${translation[language]?.msg_funcion_solo_administradores ? translation[language]?.msg_funcion_solo_administradores : "Función disponible solo para Administradores."}`, //mensaje principal
          null, //mensaje secundario
          false, //indica si hay o no boton de cancelar
          `${translation[language]?.boton_aceptar ? translation[language]?.boton_aceptar : "Aceptar"}`, //texto de boton de aceptar
          `${translation[language]?.boton_cancelar ? translation[language]?.boton_cancelar : "Cancelar"}` //texto de boton de cancelar
        );
        return;
      }
      let page = locationData?.dataConfig?.currentPage ? locationData?.dataConfig?.currentPage : 1
      getData(true, page)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) 

    //con este efecto llamamos a la funcion para obtener la data al momento de cambiar de pagina, de numero de mostrar o filtrado
    useEffect(()=> {
      if(!inicio){
      //Si este parametro no esta vacio significa que el usuario escribio algo, se espera 1 segundo para buscar
        if(dataConfig.searchTerm !==""){
          setLoadingData(true)
          const delayDebounceFn = setTimeout(() => {
            getData(false, 1, dataConfig.pageNumberLimit, dataConfig.pageMinNumber)
          }, 1000);
          return () => clearTimeout(delayDebounceFn);
        }else{
          getData(false, 1, dataConfig.pageNumberLimit, dataConfig.pageMinNumber)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConfig.searchTerm, dataConfig.itemsPerPage, dataConfig.filter])

    //con este efecto actualizamos la variable de los filtros cuando cambie de idioma
    useEffect(()=> {
      if(!inicio){
        setFiltros(JSON.parse(JSON.stringify([
          { value: 0, label: `${translation[language]?.etiqueta_todos ? translation[language]?.etiqueta_todos : "Todos"}`},
          { value: 1, label: `${translation[language]?.etiqueta_activos ? translation[language]?.etiqueta_activos : "Activos"}`},
          { value: 2, label: `${translation[language]?.etiqueta_inactivos ? translation[language]?.etiqueta_inactivos : "Inactivos"}`},
          { value: 3, label: `${translation[language]?.etiqueta_transicion ? translation[language]?.etiqueta_transicion : "En transición"}`},
        ])));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language])

    return (
            <Container> 
              <ModalContent
                ref={showModal}
                // acceptAction={handleAcceptAction}
                // modalContentInside={textdivContent}
              />
                <Screen>
                  <CContainer className='px-4'> 
                    <CardContent
                      data={propietarios}
                      dataConfig={dataConfig} // configuracion del cu, almacenamos paginacion, filtrado, busqueda, etc
                      getData={getData}
                      loadingData={loadingData}
                      setDataConfig={setDataConfig}
                      filtros={filtros}
                      handleChangeFiltros={handleChangeFiltros}
                      goToEditarPropietario={goToEditarPropietario}
                      handleGoToTransferirArte={handleGoToTransferirArte}
                      goToVerArtesPropietario={goToVerArtesPropietario}
                      //traducciones
                      translation={translation}
                      language={language}
                    />                             
                  </CContainer>
                </Screen>
            </Container>
    )
}


const Container = styled.div`
  margin: 50px auto;
`
const Screen = styled.div`
`